<template>
  <ScModal
    :show="show"
    class="change-communication-settings-survey-modal"
    @close="close"
  >
    <div class="modal-body">
      <img
        class="icon alert-icon"
        alt="alert"
        src="https://cdn.dsmcdn.com/seller-center/account/images/alert.svg"
      >
      <span class="text">
        {{ title }}
      </span>
      <span class="question">
        {{ $t(`account.changeCommunicationSettingSurvey.question`) }}
      </span>
      <div class="reasons-wrapper">
        <ScRadio
          class="reason"
          :val="reasons.NOT_RECEIVE"
          v-model="params.reason"
        >
          {{ $t(`account.changeCommunicationSettingSurvey.reasons.notReceive.${channel.channel || 'SMS'}`) }}
        </ScRadio>
        <ScRadio
          class="reason"
          :val="reasons.TOO_MUCH"
          v-model="params.reason"
        >
          {{ $t(`account.changeCommunicationSettingSurvey.reasons.tooMuch.${channel.channel || 'SMS'}`) }}
        </ScRadio>
        <ScRadio
          class="reason"
          :val="reasons.NOT_RELATED"
          v-model="params.reason"
        >
          {{ $t(`account.changeCommunicationSettingSurvey.reasons.notRelated.${channel.channel || 'SMS'}`) }}
        </ScRadio>
        <ScRadio
          class="reason"
          :val="reasons.NOT_INTEREST"
          v-model="params.reason"
        >
          {{ $t(`account.changeCommunicationSettingSurvey.reasons.notInterest.${channel.channel || 'SMS'}`) }}
        </ScRadio>
        <ScRadio
          class="reason"
          :val="reasons.OTHER"
          v-model="params.reason"
        >
          Diğer
        </ScRadio>
        <ScInput
          :is-invalid="errors.has('other')"
          v-show="showOtherReasonInput"
          v-validate="validationRules.other"
          name="other"
          class="other-reason"
          v-model="params.other"
          maxlength="250"
          :placeholder="$t(`account.changeCommunicationSettingSurvey.placeholders.otherInput`)"
        />
      </div>
      <div class="actions-wrapper">
        <ScButton
          variant="primary"
          class="form-button close-btn"
          @click="close"
        >
          {{ $t('account.changeCommunicationSettingSurvey.actions.close') }}
        </ScButton>
        <ScButton
          variant="secondary"
          class="form-button submit-btn"
          @click="onSubmit"
        >
          {{ $t(`account.changeCommunicationSettingSurvey.actions.approve`) }}
        </ScButton>
      </div>
    </div>
  </ScModal>
</template>

<script>
import ScButton from '@trendyol/sc-ui-kit/ScButton';
import ScModal from '@trendyol/sc-ui-kit/ScModal';
import ScRadio from '@trendyol/sc-ui-kit/ScRadio';
import ScInput from '@trendyol/sc-ui-kit/ScInput';

const REASONS = {
  NOT_RECEIVE: 'NOT_RECEIVE',
  NOT_INTEREST: 'NOT_INTEREST',
  TOO_MUCH: 'TOO_MUCH',
  OTHER: 'OTHER',
  NOT_RELATED: 'NOT_RELATED',
};

export default {
  name: 'ChangeCommunicationSettingsSurveyModal',
  components: {
    ScButton,
    ScModal,
    ScRadio,
    ScInput,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    channel: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      params: {
        reason: REASONS.NOT_RECEIVE,
        other: '',
      },
    };
  },
  methods: {
    async close () {
      this.$emit('close', {
        channel: this.channel,
      });
    },
    async onSubmit () {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        return false;
      }

      const params = this.params;

      params.other = params.other
        ? params.other
        : null;

      this.$emit('submit', {
        channel: this.channel,
        params: this.params,
      });
    },
  },
  computed: {
    validationRules () {
      return {
        other: { required: this.params.reason === REASONS.OTHER, max: 250 },
      };
    },
    showOtherReasonInput () {
      return this.params.reason === REASONS.OTHER;
    },
    reasons () {
      return REASONS;
    },
  },
  watch: {
    async show (newValue) {
      if (newValue) {
        this.params.reason = REASONS.NOT_RECEIVE;
        this.params.other = '';

        await this.$validator.reset();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .change-communication-settings-survey-modal{
    position: fixed !important;

    ::v-deep .modal-dialog {
      max-height: unset !important;
    }

    & .modal-body{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 30px;

      .text{
        font-size: 20px;
        font-weight: 500;
        color: #273142;
        text-align: center;
        margin: 30px 0 10px 0;
      }

      .alert-icon {
        width: 100px;
        margin: 0 auto;
      }

      .form-button{
        margin-top: 20px;
      }
    }

    .question {
      color: #273142;
      font-size: 13px;
      font-weight: 500;
      margin: 30px 0;
    }

    .reasons-wrapper {
      display: flex;
      flex-direction: column;
      color: #273142;
      margin-bottom: 10px;

      .reason:not(:last-child) {
        margin-bottom: 20px;
      }
    }

    .actions-wrapper {
      display: flex;
      flex-direction: column;
    }

    @media only screen and (max-width:640px) {
      .text {
        font-size: 13px !important;
      }
      .question {
        font-size: 11px;
        margin: 15px 0;
      }
      .reasons-wrapper .reason:not(:last-child) {
        margin-bottom: 10px;
      }
      .actions-wrapper button {
        font-size: 10px;
      }
    }
  }
</style>
